import styles from './style.module.css';
import Image from 'next/image';
import {ImageInterface} from '@interfaces/images';
import {LocaleEnum} from '@enums/locale';

export function ProductTabImagePane({
  isActive,
  images,
  locale,
  alt,
}: {
  isActive: boolean;
  alt: string;
  images: ImageInterface[];
  locale: LocaleEnum;
}) {
  return (
    <div
      className={`${styles.productTabPane} ${isActive && styles.isActive} row`}
    >
      {images.map((image, index) => {
        return (
          <div key={index} className="col-sm-6">
            <Image
              alt={alt}
              src={image[`image_${locale}`]}
              height={350}
              width={350}
            />
          </div>
        );
      })}
    </div>
  );
}
